<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col cols="8" lg="4">
          <b-card-group>
            <b-card v-if="!isLoggedIn" no-body class="p-2">
              <b-card-body>
                <b-form name="login">
                  <p v-show="isLoginFailed" class="text-danger">{{ $t('auth.failed') }}</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <font-awesome-icon icon="fa-solid fa-keyboard" />
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input v-model="code" type="text" class="form-control" autofocus
                      :placeholder="$dt('global.code', '0000')" />
                  </b-input-group>

                  <b-row>
                    <b-col cols="12">
                      <b-button name="login" block variant="primary" class="px-4 w-100" @click="login"
                        :disabled="isLoading">{{ $dt('auth.login', 'Login') }}</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card v-else no-body class="p-2">
              <b-card-body>
                <p>{{ $dt('tv_code.already_logged_in', 'It appears that you are already logged in to a session.') }}</p>
                <p>{{ $dt('tv_code.logout_question', 'Would you like to log out?') }}</p>
                <b-button variant="primary" class="w-100" @click="logout">{{ $dt('auth.logout', 'Logout') }}</b-button>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VT from '@/store/types';

export default {
  data() {
    return {
      code: '',
      remember_name: navigator.userAgent,

      isLoading: false,
      isLoginFailed: false,
    };
  },
  components: {},
  computed: {
    ...mapGetters('Auth', ['user', 'isLoggedIn']),
  },
  methods: {
    ...mapActions('Auth', [VT.LOGIN, VT.LOGOUT]),
    login() {
      this.isLoginFailed = false;
      this.isLoading = true;
      this[VT.LOGIN]({ tv: true, code: this.code, remember_name: this.remember_name }).then(() => {
        this.$router.replace({ path: '/' }).catch(() => { });
      }).catch(() => {
        this.isLoginFailed = true;
        this.isLoading = false;
      });
    },
    logout() {
      this[VT.LOGOUT]({ redirect: false });
    }
  }
};
</script>
<style lang=scss >
.oauth-btn {
  padding: 0.2em 0.6em;
  white-space: nowrap;

  img {
    max-height: 1.4em;
    padding-right: 0.2em;
    vertical-align: -0.3em;
  }
}
</style>
